// @flow

import * as React from 'react';

import { selectOneProductErrors } from '@gandi/cart';
import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import ProductItem from './components/ProductItem';

type Props = { product: DecoratedProduct };

export default (React.memo<Props>(({ product }: Props) => {
  const { __ } = useTranslator();
  const beforeTaxes = product.total?.before_taxes;
  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, { productId: product.id }),
  );

  const label = product.label || __('Other Product');

  return (
    <ProductItem
      key={`${product.id}-row`}
      hasTaxes={product.hasTaxes}
      priceBeforeTaxes={product.isWorking ? undefined : beforeTaxes}
      label={label}
      productId={product.id}
      errors={productErrors}
    />
  );
}): React.ComponentType<Props>);
